// Header.js
import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/global.css';
import { SearchContext } from '../context/SearchContext';

function Header() {
  const { setQuery } = useContext(SearchContext);
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu when a link is clicked (for mobile UX)
  const handleNavClick = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="brand">The Tasty Dine</div>

      {/* Hamburger icon for mobile */}
      <button
        className={`hamburger${menuOpen ? ' open' : ''}`}
        aria-label="Toggle navigation menu"
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      <nav className={`nav-links${menuOpen ? ' mobile-open' : ''}`}>
        <NavLink
          to="/"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
          onClick={handleNavClick}
        >
          Home
        </NavLink>
        <NavLink
          to="/about"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
          onClick={handleNavClick}
        >
          About
        </NavLink>
        <NavLink
          to="/menu"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
          onClick={handleNavClick}
        >
          Menu
        </NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
          onClick={handleNavClick}
        >
          Contact
        </NavLink>
        <NavLink
          to="/booking"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
          onClick={handleNavClick}
        >
          Booking
        </NavLink>
        <NavLink
          to="/review"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
          onClick={handleNavClick}
        >
          Reviews
        </NavLink>
      </nav>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search for a dish in a Menu"
          onChange={(e) => setQuery(e.target.value.toLowerCase())}
        />
      </div>
    </header>
  );
}

export default Header;
